// Products Mutations

export const updateProductsList = (state, payload) => {
  state.productsList = payload
}

export const fetchProductInfo = (state, payload) => {
  state.productInfo = payload
}

export const setFullSaleProductsList = (state, payload) => {
  state.fullSaleProductsList = payload
}

export const setFullPurchaseProductsList = (state, payload) => {
  state.fullPurchaseProductsList = payload
}

export const setFullProductsList = (state, payload) => {
  state.fullProductsList = payload
}
